import Money from "../../../lib/Money";
import React from "react";
import clsx from "clsx";

export default function CartDisplayTotal({ label, value, className, optional, id }) {

  // savings line is optional, suppress when zero
  if (!value && optional)
    return null;

  // negative quantities in bright colour (gold, green)
  let amountClasses = clsx([
    'text-right', (value < 0) ? 'text-brand-bright' : ''
  ]);

  className = clsx("grid grid-cols-2 py-1", className);

  id = "summary-" + id;
  return <div className={className} id={id}>
    <div className="lbl">{label}:</div>
    <div className={amountClasses}>
      {new Money(value).toString()}
    </div>
  </div>
}
